import React, { SetStateAction } from 'react'
import { IFrameModal } from '..'
import styles from './EasyIFrameModal.module.scss'

interface EasyIFrameModalProps {
  /**
   * The accessibility title for the modal.
   */
  title?: string
  /**
   * The URL of the content to display inside the iframe.
   */
  src: string
  /**
   *
   * The content to use to trigger the modal. This should be a function that
   * returns an Action component.
   */
  children: (open: React.Dispatch<SetStateAction<boolean>>) => React.ReactNode
  modalProps?: object
  iframeProps?: object
}

/**
 * `<IframeActionLink>` displays external links within an Iframe modal.
 * Pass the trigger element as a child function that receives an `open` function
 * to open the modal.
 */
export function EasyIFrameModal({
  title,
  src,
  children,
  modalProps,
  iframeProps,
}: EasyIFrameModalProps) {
  const [isOpen, setIsOpen] = React.useState(false)
  return (
    <>
      <div className={styles.btnContainer}>{children(setIsOpen)}</div>

      <IFrameModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        label={title}
        url={src}
        iframeProps={iframeProps}
        {...modalProps}
      />
    </>
  )
}

export interface VirtualTourModalProps
  extends Omit<EasyIFrameModalProps, 'children'> {
  actionClassName?: string
  actionProps?: object
}
